import React from "react";
import BarraSupDent from "../../../commons/BarraSupDent";
import NewUserTechnicianAuth from "./Component/NewUserTechnicianAuth";

class CreateNewAccount extends React.Component {
  // fake authentication Promise
  authenticate() {
    return new Promise((resolve) => setTimeout(resolve, 1000)); // 2 seconds
  }

  componentDidMount() {
    this.authenticate().then(() => {
      const ele = document.getElementById("ipl-progress-indicator");
      if (ele) {
        // fade out
        ele.classList.add("available");
        setTimeout(() => {
          // remove from DOM
          ele.outerHTML = "";
        }, 1000);
      }
    });
  }

  render() {
    return (
      <React.Fragment>
        <BarraSupDent />
        <div id="alert" className="alert alert-danger d-none" role="alert">
          <p className="text-center">Please enter your phone number</p>
        </div>
        <NewUserTechnicianAuth />
      </React.Fragment>
    );
  }
}

export default CreateNewAccount;
